import * as React from "react";
import {API_URL, TIKTOK_APP_ID, APP_URL } from '../../../settings/local_settings';
import {AuthUrlLinkBase} from "./AuthUrlLinkBase";
import {TikTokConnectButton} from "./TikTokConnectButton";
import { withTranslation } from 'react-i18next';

export class TikTokLinkComponentClass extends AuthUrlLinkBase {

    _getAuthURL(){
        const redirectUri = encodeURIComponent(`${APP_URL}connect-tiktok`);
        return `https://business-api.tiktok.com/portal/auth?app_id=${TIKTOK_APP_ID}&state=your_custom_params&redirect_uri=${redirectUri}`;
    }

    _getDeleteUrl(){
        return API_URL + 'agency/tiktok-connection/delete/';
    }

    renderConnectionButton() {
        return <TikTokConnectButton onClick={this.redirectToAuthPage} />;
    }

    renderDisconnectButton() {
        const { t } = this.props;
        return <button className="btn" onClick={this.deleteAgencyConnection}>{t('tiktok_link.disconnect_from_tiktok_ads')}</button>
    }


    redirectToAuthPage() {
        window.location.href = this._getAuthURL();
    }
}

export const TikTokLinkComponent = withTranslation()(TikTokLinkComponentClass);
export default TikTokLinkComponent;
